// extracted by mini-css-extract-plugin
export default {"paymentScreenControls":"paymentScreenControls__tQnH8P","redirection":"redirection__VFa8l0"};